import { useEffect, useState } from "react";

import { getData } from "../../../../../services";
import { MeterPlan } from "../../../../../components/parts";
import MeterTypes from "./MeterTypes";

export const Meters = ({ buildingId, complexId }) => {
  const [meterPlan, setMeterPlan] = useState();

  useEffect(() => {
    const url = buildingId
      ? `/praas/v2/buildings/${buildingId}/properties/meters/`
      : `/praas/v2/complexes/${complexId}/properties/meters/`;

    getData(url, setMeterPlan);
  }, [buildingId, complexId]);

  if (buildingId) {
    return <MeterPlan meterPlan={meterPlan} />;
  } else if (complexId) {
    return <MeterTypes meters={meterPlan} />;
  } else {
    return null;
  }
};
